/**
 * Created by asutosh on 03/01/19.
 */
import {CustomDateModel} from '../CustomDate/custom-date.model';
import {EventModel} from '../EventModel/Event.model';

export class WebhookLogModel {
  account_id?: string;
  webhook_id?: string;
  created_at?: CustomDateModel;
  event_type?: string;
  event_type_id?: string;
  payload?: any;
  response_content?: any;
  response_status_code?: string;
  status?: string;
  event_id?: string;
  id?: string;
  enabled?: boolean;
  updated_at?: CustomDateModel;
  attempt_count?: number;
  url?: string;

  constructor(webhookLogData?: Partial<WebhookLogModel>) {
    this.created_at = new CustomDateModel();
    this.updated_at = new CustomDateModel();

    if (webhookLogData) {
      Object.assign(this, webhookLogData);
      this.payload = this.parseJsonSafelyDeep(webhookLogData.payload);
      this.response_content = this.parseJsonSafelyDeep(webhookLogData.response_content);
    }
  }

  private parseJsonSafelyDeep(value: any): any {
    // Try to parse strings that look like JSON objects or arrays
    if (typeof value === 'string') {
      try {
        const parsed = JSON.parse(value);
        return this.parseJsonSafelyDeep(parsed);
      } catch {
        return value;
      }
    }

    // Recursively process arrays
    if (Array.isArray(value)) {
      return value.map((item) => this.parseJsonSafelyDeep(item));
    }

    // Recursively process object values
    if (typeof value === 'object' && value !== null) {
      const parsedObj: any = {};
      for (const key in value) {
        if (value.hasOwnProperty(key)) {
          parsedObj[key] = this.parseJsonSafelyDeep(value[key]);
        }
      }
      return parsedObj;
    }

    // For anything else (numbers, booleans, null, etc.)
    return value;
  }


}
